import React from 'react';
import { connect } from 'cpcs-reconnect';
import { compose } from 'redux';

import toSnake from 'to-snake-case';
import sheet from './sheet';
import injectSheet from 'lib/sheet';
import { ConnectedPopup, sheet as popupSheet } from 'components/Popup';
import { getPopupParamsByName, hidePopupByName } from 'domain/ui';
import CustomerSignUpForm from 'components/CustomerSignUpForm';

export const customerSignUpSheet = {
  ...popupSheet,
  overlay: {
    ...popupSheet.overlay,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 999, // Just below the container
  },
  container: {
    ...popupSheet.container,
    position: 'fixed',
    right: 0,
    top: 0,
    width: 500,
    height: '100vh',
    maxHeight: '100vh',
    transform: 'none',
    boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    borderRadius: 0,
    borderLeft: '1px solid #e5e7eb',
    animation: '$slideInFromRight 0.3s ease-out',
    zIndex: 1000, // Set z-index to 1000
  },
  '@keyframes slideInFromRight': {
    '0%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(0)',
    },
  },
  header: {
    display: 'none', // Hide the default header since we're using the form's header
  },
  content: {
    padding: 0,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  close: {
    ...popupSheet.close,
    position: 'absolute',
    right: 20,
    top: 20,
    width: 32,
    height: 32,
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 1001, // Above the container
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20,
    color: '#6b7280',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#f3f4f6',
      color: '#374151',
    },
    '&::before': {
      content: '"×"',
      fontWeight: 'bold',
      fontSize: 24,
    },
  },
};

export const Popup = injectSheet(customerSignUpSheet)(ConnectedPopup);

export const CustomerSignUpPopup = ({ classes, hidePopupByName }) => {
  const closePopup = () => {
    hidePopupByName('CUSTOMER_SIGN_UP');
  };

  return (
    <Popup name='CUSTOMER_SIGN_UP' onClose={closePopup}>
      <div className={classes.formWrapper}>
        <CustomerSignUpForm onCancel={closePopup} />
      </div>
    </Popup>
  );
};

export default compose(
  injectSheet(sheet),
  connect({
    popupParams: getPopupParamsByName(toSnake('customerSignUp').toUpperCase()),
    hidePopupByName,
  })
)(CustomerSignUpPopup);
